import React, { FC } from 'react';
import GooglePayButton from '@google-pay/button-react';
import CircularProgress from '@mui/material/CircularProgress';
import { googlePayEnvironment, googlePayMerchantId, googlePayMerchantName } from '../../../constants/configuration';

interface CustomGooglePayButtonProps {
  isLoading: boolean;
  isGooglePaymentAvailable: boolean;
  gatewayMerchantId: string;
  currentTotalPrice: string;
  googlePay: (token: string, email: string) => void;
}

export const CustomGooglePayButton: FC<CustomGooglePayButtonProps> = ({
  isLoading,
  isGooglePaymentAvailable,
  gatewayMerchantId,
  currentTotalPrice,
  googlePay,
}) => {
  /* GooglePay: блокировка экрана пока идет переадресация  на страницу 3DS */
  const blockWindowWhenLoading = () => {
    return (
      <div className="block-screen">
        <CircularProgress size={150} color="primary" />
      </div>
    );
  };

  return (
    <div className="google__pay">
      {isLoading ? blockWindowWhenLoading() : null}
      {isGooglePaymentAvailable ? (
        <GooglePayButton
          environment={googlePayEnvironment as google.payments.api.Environment}
          paymentRequest={{
            emailRequired: true,
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: [
              {
                type: 'CARD',
                parameters: {
                  allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                  allowedCardNetworks: ['MASTERCARD', 'VISA'],
                },
                tokenizationSpecification: {
                  type: 'PAYMENT_GATEWAY',
                  parameters: {
                    gateway: 'platon',
                    gatewayMerchantId,
                  },
                },
              },
            ],
            merchantInfo: {
              merchantId: googlePayMerchantId,
              merchantName: googlePayMerchantName,
            },
            transactionInfo: {
              totalPriceStatus: 'FINAL',
              totalPriceLabel: 'Total',
              totalPrice: currentTotalPrice,
              currencyCode: 'UAH',
              countryCode: 'UA',
            },
          }}
          onLoadPaymentData={(paymentRequest) => {
            googlePay(paymentRequest.paymentMethodData.tokenizationData.token, paymentRequest.email || '');
          }}
          buttonType="plain"
        />
      ) : null}
    </div>
  );
};
